import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Organization, OrganizationSettings } from '../../../types/organization';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const updateOrganizationSettings = async (formData: OrganizationSettings): Promise<Organization> => {
  const response = await CustomAxios.put(`organizations/update-settings`, { settings: formData });
  return response.data;
};

export function useUpdateOrganizationSettings() {
  return useMutation({
    mutationFn: (formData: OrganizationSettings) => updateOrganizationSettings(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentOrganization] });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data: Organization = err.response.data as Organization;
        queryClient.setQueryData([queryKeys.currentOrganization], data);
      }
    },
  });
}
